import { Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { logbaseService } from "../../services/logbase.service";
import { PrefectureAddData, PrefectureEditData } from "../../models/pfepModels";

@Component({
  selector: "app-prefectures-popup",
  templateUrl: "./prefectures-popup.component.html",
  styleUrls: ["./prefectures-popup.component.scss"],
})
export class PrefecturesPopupComponent implements OnInit {
  displayedPrefecColumns = ["prefecturesJP", "prefecture", "region"];
  public dataSource;

  public addPrefecData: PrefectureAddData = {
    prefecturesJP: "",
    prefecture: "",
    region: "",
    user: "",
  };
  public editPrefecData: PrefectureEditData = {
    prefectureNo: 0,
    prefecturesJP: "",
    prefecture: "",
    region: "",
    user: "",
  };
  // prefectureData = new FormControl("", [Validators.required]);
  addPrefectureSuccess = false;
  addPrefectureError = false;
  addPrefectureErrorMessage: any;
  editPrefectureError = false;
  editPrefectureSuccess = false;
  editPrefectureErrorMessage: any;
  deletePrefectureSuccess = false;
  deletePrefectureError = false;
  confirmDeletePrefecture = false;
  deletePrefectureErrorMessage: any;

  prefectureAddForm: FormGroup;
  prefectureEditForm: FormGroup;

  constructor(
    public snackBar: MatSnackBar,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PrefecturesPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private translate: TranslateService,
    private router: Router,
    private logbaseService: logbaseService,
    private spinner: NgxSpinnerService
  ) {}

  addPrefecturesJPControl = new FormControl("", [
    Validators.required,
    // Validators.pattern("^[A-Za-z]+$"),
  ]);
  addPrefectureControl = new FormControl("", [
    Validators.required,
    Validators.pattern("^[A-Za-z]+$"),
  ]);
  addRegionControl = new FormControl("", [
    Validators.required,
    Validators.pattern("^[A-Za-z]+$"),
  ]);
  editPrefecturesJPControl = new FormControl("", [
    Validators.required,
    // Validators.pattern("^[A-Za-z]+$"),
  ]);
  editPrefectureControl = new FormControl("", [
    Validators.required,
    Validators.pattern("^[A-Za-z]+$"),
  ]);
  editRegionControl = new FormControl("", [
    Validators.required,
    Validators.pattern("^[A-Za-z]+$"),
  ]);

  getPrefecErrorMessage(value) {
    return value.hasError("required")
      ? this.translate.instant("Required")
      : value.hasError("pattern")
      ? this.translate.instant("Only Alphabets Allowed")
      : "";
  }

  ngOnInit() {
    this.prefectureAddForm = this.fb.group({
      addPrefecturesJP: [
        "",
        [
          Validators.required,
          Validators.pattern("/[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[々〆〤ヶ]+/u"),          
        ],
      ],
      addPrefecture: [
        "",
        [Validators.required, Validators.pattern("^[A-Za-z]+$")],
      ],
      addRegion: ["", [Validators.required, Validators.pattern("^[A-Za-z]+$")]],
    });

    if (this.data.type === "EditPrefecData") {
    this.prefectureEditForm = this.fb.group({
        editPrefecture: [
          this.data.prefecData.prefecture,
          [Validators.required, Validators.pattern("^[A-Za-z]+$")],
        ],
        editPrefecturesJP: [
          this.data.prefecData.prefecturesJP,
          [
            Validators.required,
            Validators.pattern("/[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[々〆〤ヶ]+/u"),
          ],
        ],
        editRegion: [
          this.data.prefecData.region,
          [Validators.required, Validators.pattern("^[A-Za-z]+$")],
        ],
    });
    }
  }

  getAddFormFieldsName(fieldName: string) {
    return this.prefectureAddForm.get(fieldName);
    }
  
  getFormFieldsName(fieldName: string) {
    return this.prefectureEditForm.get(fieldName);
  }

  onNoClick(): void {
    setTimeout(function() {}, 1000);
    this.dialogRef.close();
  }

  confirmAdd(type) {
    if (type === "AddPrefecData") {
      this.addPrefecData.prefecture =
        this.prefectureAddForm.value.addPrefecture;
      this.addPrefecData.prefecturesJP =
        this.prefectureAddForm.value.addPrefecturesJP;
      this.addPrefecData.region = this.prefectureAddForm.value.addRegion;
      this.addPrefecData.user = JSON.parse(localStorage.getItem("currentUser"));
      this.addPrefecInformation(this.addPrefecData);
    } else if (type === "EditPrefecData") {
      this.editPrefecData.prefectureNo = this.data.prefecData.prefectureNo;
      this.editPrefecData.prefecture =
        this.prefectureEditForm.value.editPrefecture;
      this.editPrefecData.prefecturesJP =
        this.prefectureEditForm.value.editPrefecturesJP;
      this.editPrefecData.region = this.prefectureEditForm.value.editRegion;
      this.editPrefecData.user = JSON.parse(
        localStorage.getItem("currentUser")
      );

      this.editPrefecInformation(this.editPrefecData);
    }
  }

  addPrefecInformation(prefecData) {
    this.spinner.show();
    this.logbaseService.addPrefecture(prefecData).subscribe(
      (response) => {
        this.addPrefectureSuccess = true;
        this.addPrefectureError = false;
        this.spinner.hide();
        // this.dialogRef.close();
      },
      (error) => {
        this.spinner.hide();
        // this.dialogRef.close();
        this.addPrefectureSuccess = false;
        this.addPrefectureError = true;
        this.addPrefectureErrorMessage = error.error.result;
        this.spinner.hide();
      }
    );
    this.dialogRef.close();
  }
  editPrefecInformation(prefecData) {
    this.spinner.show();
    this.logbaseService.editPrefecture(prefecData).subscribe(
      (response) => {
        this.addPrefectureSuccess = true;
        this.addPrefectureError = false;
        this.spinner.hide();
        this.dialogRef.close();
      },
      (error) => {
        if (error.status === 422) {
          this.spinner.hide();
          this.dialogRef.close();
          this.editPrefectureSuccess = false;
          this.editPrefectureError = true;
          this.editPrefectureErrorMessage = error.error.result;
        } else if (error.status === 409) {
          this.spinner.hide();
          this.dialogRef.close();
          this.editPrefectureSuccess = false;
          this.editPrefectureError = true;
          this.editPrefectureErrorMessage = error.error.result;
        } else {
          this.spinner.hide();
          this.dialogRef.close();
        }
      }
    );
  }
  deletePrefecInformation(prefecData) {
    let prefectureId = prefecData.prefectureNo;
    this.spinner.show();
    this.logbaseService.deletePrefecture(prefectureId).subscribe(
      (response) => {
        this.deletePrefectureSuccess = true;
        this.deletePrefectureError = false;
        this.spinner.hide();
        this.dialogRef.close();
      },
      (error) => {
        if (error.status === 422) {
          this.spinner.hide();
          this.dialogRef.close();
          this.deletePrefectureSuccess = false;
          this.deletePrefectureError = true;
          this.deletePrefectureErrorMessage = error.error.result;
        } else if (error.status === 409) {
          this.spinner.hide();
          this.dialogRef.close();
          this.deletePrefectureSuccess = false;
          this.deletePrefectureError = true;
          this.deletePrefectureErrorMessage = error.error.result;
        } else {
          this.spinner.hide();
          this.dialogRef.close();
        }
      }
    );
  }
}
